import Spinner from '@mui/material/CircularProgress'
import { useTranslation } from 'react-multi-lang'



export const Wait =()=>{
const t=useTranslation()
return (
<div style={{
    width:'100%',
    height:'100%',
    background:'rgb(165, 164, 164,0.4)',
    display:'flex',
    justifyContent:'center',
    alignItems:'top',
    position:'fixed',
    zIndex:90,
    top:0,
    left:0,
    padding:'7rem 1rem'
    
  }}>
    <Spinner variant='indeterminate'/>
    <span style={{margin:'0 10px',fontSize:'1.4rem',color:'white'}}>
      {t("just_momont")}
    </span>
  </div>)
  }